import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

export const TextHeaderEl = () => {
    const isDesktop = useMediaQuery('(min-width: 540px)')

    return (
        <HighlightedText
            text="ΞΥΣΤΕ ΤΑ ΕΙΣΙΤΗΡΙΑ ΚΑΙ ΠΑΡΤΕ ΤΟ ΜΠΟΝΟΥΣ ΣΑΣ"
            highlights={[{ word: 'ΤΟ' }, { word: 'ΜΠΟΝΟΥΣ' }, { word: 'ΣΑΣ' }]}
            breakAfterWords={isDesktop ? ['ΠΑΡΤΕ'] : ['ΕΙΣΙΤΗΡΙΑ', 'ΠΑΡΤΕ']}
            className={styles.text_header}
        />
    )
}
